define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LocationSummaryViewModel = exports.LocationColorSummaryViewModel = void 0;
    class LocationColorSummaryViewModel {
        constructor(data) {
            this.CharacterLimit = 24;
            this.NormalizeHexValues = (hex) => {
                return hex && hex.indexOf("#") > -1 ? hex.substring(1) : hex;
            };
            this.HideOnExpand = (data, event) => {
                event.target.parentNode.removeChild(event.target);
            };
            data.HexValue = this.NormalizeHexValues(data.HexValue);
            $.extend(this, {
                HexValue: null,
                DisplayValue: null,
                Instructions: null,
                ExpandedInstructions: null
            }, data);
            if (this.Instructions && this.Instructions.length > this.CharacterLimit) {
                this.ExpandedInstructions = this.Instructions.substr(this.CharacterLimit);
                this.Instructions = this.Instructions.substr(0, this.CharacterLimit);
            }
            this.IsMetallic = this.DisplayValue && this.DisplayValue.indexOf('Metallic') > -1;
            this.IsWhite = this.HexValue && this.HexValue.toLowerCase() === 'ffffff';
        }
    }
    exports.LocationColorSummaryViewModel = LocationColorSummaryViewModel;
    class LocationSummaryViewModel {
        constructor(data) {
            data = $.extend({
                Id: 0,
                CustomImprintingType: '',
                CustomImprintingTypeIcon: '',
                ImagePath: null,
                FileType: '',
                Colors: [],
                FooterTemplate: ''
            }, data);
            ko.mapping.fromJS(data, {}, this);
        }
    }
    exports.LocationSummaryViewModel = LocationSummaryViewModel;
});
//# sourceMappingURL=LocationSummary.js.map